$(document).on('miscellaneous-ready', function() {
  $('.rollup_checkbox').bootstrapSwitch();
  $('.accept_dea_lookup_failure_checkbox').bootstrapSwitch();
  $('.accept_ncpdp_lookup_failure_checkbox').bootstrapSwitch();
  $('.accept_npi_lookup_failure_checkbox').bootstrapSwitch();
  $('.waiver_dea_support_checkbox').bootstrapSwitch();
  $('.minor_checkbox').bootstrapSwitch('onText', 'Discard')
    .bootstrapSwitch('offText', 'Retain')
    .bootstrapSwitch('onColor', 'danger')
    .bootstrapSwitch('offColor', 'success');
  $('.dea_number_management_checkbox').bootstrapSwitch();
  $('.allow_duplicates_checkbox').bootstrapSwitch();
  $('.display_duplicates_checkbox').bootstrapSwitch();
  $('.hash_based_deduplication_checkbox').bootstrapSwitch();
  $('.v3_deduplication_hash_checkbox').bootstrapSwitch();
  $('.state_licenses_checkbox').bootstrapSwitch();
  $('.fault_tolerance_checkbox').bootstrapSwitch();
  $('[data-bs-toggle="tooltip"], [data-bs-toggle-tooltip="tooltip"]').each(function(i, el) {
    new bootstrap.Tooltip(el);
  });
  $('.drug_schedule_active_checkbox').bootstrapSwitch({
    onText: 'Excluded',
    offText: 'Allowed',
    onColor: 'danger',
    offColor: 'success'
  });

  $('.dea_schedule_active_checkbox').bootstrapSwitch({
    onText: 'Required',
    offText: 'Preferred',
    onColor: 'danger',
    offColor: 'success'
  });
});

$(document).on('ucf-fields-ready', function() {
  $('.ucf_error_correction_toggle').bootstrapSwitch();
});

$(document).on('switchChange.bootstrapSwitch', '.ucf_error_correction_toggle', function(event, state) {
  const $toggle = $(event.target);
  const pmpId = $('input[name="universal_claim_form_field[pmp_id]"]').val();
  const toggle_field = $toggle[0].name;

  $toggle.bootstrapSwitch('disabled', true);
  $.ajax({
    url: '/pmps/ucf_fields/update_error_correction',
    method: 'PATCH',
    data: {
      pmp_id: pmpId,
      field: toggle_field,
      value: state.toString()
    }
  }).done(function() {
    $('#alert-text').text('UCF Error Correction setting updated successfully.');
    $('#page-alert').removeClass('alert-danger').addClass('alert-success').show('fast');
  }).fail(function() {
    $(event.target).bootstrapSwitch('state', !state, true);
    $('#alert-text').text('Failed to update UCF Error Correction setting.');
    $('#page-alert').removeClass('alert-success').addClass('alert-danger').show('fast');
  }).always(function() {
    $toggle.bootstrapSwitch('disabled', false);
  });
});

$(document).on('switchChange.bootstrapSwitch', '.fault_tolerance_checkbox', function() {
  const fault_sel = '#pmp_fault_tolerance_percentage, #pmp_fault_tolerance_minimum';
  $(fault_sel).prop('disabled', !$(this).prop('checked'));
});
